"use strict";

TYCOON.pageScript = TYCOON.pageScript || {
  init: {}
};
TYCOON.pageScript = function () {
  // コンストラクタ  =================================================================
  function init() {
    $('.js-ticker')[0] && TYCOON.common.initTicker();
  }
  return {
    init: init
  };
}();
TYCOON.common.init(TYCOON.pageScript.init);